import React, { useState, useEffect } from "react";
import { useAppContext } from "./../AppContext"; // Adjust the path as needed

export default function AdminHeader() {
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { User, OpenDrawerFromAdminHeader, setOpenDrawerFromAdminHeader } =
    useAppContext();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    window.location.href = "/";
  };
  return (
    <div style={{ display: "flex", width: "100%", backgroundColor: "#f5f5f4" }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: MyWidth >= 1024 ? "flex-end" : "space-between",
        }}
      >
        {MyWidth >= 1024 ? (
          <></>
        ) : (
          <div style={{ padding: 5 }}>
            {OpenDrawerFromAdminHeader ? (
              <></>
            ) : (
              <>
                <button
                  style={{
                    width: "45px", // Set width and height to the same value
                    height: "45px",
                    borderRadius: "50%", // Makes the button circular
                    backgroundColor: "#27272a", // Background color
                    color: "white", // Text color
                    border: "none", // Remove default border
                    cursor: "pointer", // Change cursor to pointer on hover
                    display: "flex",
                    alignItems: "center", // Center content vertically
                    justifyContent: "center", // Center content horizontally
                    //fontSize: "14px", // Adjust font size
                  }}
                  onClick={() => {
                    setOpenDrawerFromAdminHeader(true);
                  }}
                >
                  <a style={{ fontSize: 12 }}>Drawer</a>
                </button>
              </>
            )}
          </div>
        )}

        <div style={{ padding: 5 }}>
          <button
            style={{
              width: "45px", // Set width and height to the same value
              height: "45px",
              borderRadius: "50%", // Makes the button circular
              backgroundColor: "#27272a", // Background color
              color: "white", // Text color
              border: "none", // Remove default border
              cursor: "pointer", // Change cursor to pointer on hover
              display: "flex",
              alignItems: "center", // Center content vertically
              justifyContent: "center", // Center content horizontally
              //fontSize: "14px", // Adjust font size
            }}
            onClick={handleLogout}
          >
            <a style={{ fontSize: 12 }}>Logout</a>
          </button>
        </div>
      </div>
    </div>
  );
}
